import { httpRequest } from "../../http";
import { Launch } from "@models/launch.model";
import { LaunchSerializer } from "@models/serializers/launchSerializer";

export class CommandGetLaunch {
  async run(launchId: number): Promise<Launch> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/`;
    const response = await httpRequest<any>(url, { method: "GET" });

    const serializer = new LaunchSerializer();
    return serializer.deserialize(response);
  }
}
